import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  PageDescription,
  PageTitleBox,
} from "../../components/Paragraph/Paragraph.styled";

import chat from "../../utils/api/chat";
import {
  Label,
  SelectBox,
  SelectLab,
  StyledOption,
  Textarea,
} from "../../components/UI/Forms/Forms.styled";
import { ButtonMorpheus } from "../../components/ButtonMorpheus/ButtonMorpheus.styled";
import {
  Interpretation,
  InterpretationBox,
} from "../../components/Interpretation/Interpretation.style";
import { Dna } from "react-loader-spinner";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import ButtonNeumorphicRoot from "../../components/UI/ButtonNeumorphic/ButtonNeumorphic.styled";
import { Link, useSearchParams } from "react-router-dom";
import Divider from "../../components/UI/Divider/Divider";
import { publicIpv4 } from "public-ip";
import getUnits from "../../utils/api/getUnits";
import { MQEA } from "../../components/UI/Text/mqea/mqea.styled";
import { LogoImg } from "../../components/Header/Header";
import morpheus from "../../assets/images/askmorpheus-logo-v2-1.png";
import { loadAuth } from "../../store/applications/AuthReducer";
import { PageSubTitleH3 } from "../../components/UI/Text/Text.styled";
import { BoxRow } from "../../components/Box/Box.styled";
import {
  SuccessBox,
  SuccessIcon,
  SuccessText,
} from "../../components/Success/Success.styled";
import checkButton from "../../assets/images/icons/check-button.png";
import writeCustomerId from "../../utils/api/writeCustomerId";
import SubscriptionFR from "../../components/Subscription/SubscriptionFR";
import postFeedback from "../../utils/api/postFeedback";
import ButtonLanguage from "../../components/ButtonLanguage/ButtonLanguage";
import Panel from "../../components/Panel/Panel";
import Versions from "../../components/Versions/Versions";

export const styles = [
  "Sigmund Freud",
  "Carl Jung",
  "Frederick Perls",
  "Alfred Adler",
  // "Lacan",
  // "Tarot",
  // "Christian & Spirits",
  // "Islamic & Spirits",
  // "Jewish Talmud & Spirits",
  // "Kabbalah",
  // "Celtic",
  // "African & Voodoo",
  "Feminist",
];

export const languages = [
  "English",
  "Français",
  "Español",
  "Italiano",
  "Portugues",
  "Deutsche",
  "العربية",
];

export const HomepageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ChatBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`;

export const SendButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const UpgradeBox = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
`;

export const UpgradeCard = styled.div``;

function Homepage() {
  const [queryParameters] = useSearchParams();
  const dispatch = useAppDispatch();
  const authData = useAppSelector((state) => state.AuthReducer);
  const [loading, setLoading] = useState(false);
  const [valueClean, setValueClean] = useState("");
  const [interpretation, setInterpretation] = useState("");
  const [dreamId, setDreamId] = useState("");
  const [style, setStyle] = useState("Freud");
  const [dream, setDream] = useState("");
  const [context, setContext] = useState("");
  const [relevant, setRelevant] = useState("");
  const [language, setLanguage] = useState("English");
  // eslint-disable-next-line
  const [uid, setUid] = useState<string | null>(
    "" || window.localStorage.getItem("uid-askmorpheus")
  );
  const [ip, setIp] = useState<string | null>("");
  const [unitsCounter, setUnitsCounter] = useState(0);
  const [update, setUpdate] = useState(0);
  // eslint-disable-next-line
  const [isAuth, setIsAuth] = useState(
    false || window.localStorage.getItem("auth-askmorpheus") === "true"
  );
  const [priceTable, setPriceTable] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [successSub, setSuccessSub] = useState(false);

  useEffect(() => {
    // console.log(uid);
    // console.log(authData.uid);
    dispatch(loadAuth());
    if (uid === "" || (uid === null && authData.uid !== "")) {
      setUid(authData.uid);
    }
    // console.log(uid);
  }, [uid]); // eslint-disable-line

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const paramSuccess = queryParameters.get("success");
    const paramCancel = queryParameters.get("canceled");
    const plan = queryParameters.get("plan");

    if (paramSuccess) {
      const param = queryParameters.get("session_id");
      setSuccessSub(true);
      param && setSessionId(param);
    }

    if (plan) {
      const param = queryParameters.get("session_id");
      console.log(uid, param, plan);
      const writeCusId = async () => {
        param && uid && writeCustomerId(uid, param, plan);
      };
      writeCusId().then(() => dispatch(loadAuth()));
    }

    if (paramCancel) {
      setSuccessSub(false);
      // setMessage(
      //   "Order canceled -- continue to shop around and checkout when you're ready."
      // );
    }
  }, [sessionId]); // eslint-disable-line

  useEffect(() => {
    const setUnits = async () => {
      try {
        const ipV4 = await publicIpv4();
        setIp(ipV4);
        if (uid) {
          const units = await getUnits(uid, "");
          setUnitsCounter(units);
        } else {
          const units = await getUnits("", ipV4);
          setUnitsCounter(units);
        }
      } catch (error) {
        const ipV4 = "0.0.0.0";
        setIp(ipV4);
        if (uid) {
          const units = await getUnits(uid, "");
          setUnitsCounter(units);
        } else {
          const units = await getUnits("", ipV4);
          setUnitsCounter(units);
        }
      }
    };

    setUnits();
    // console.log(uid);
  }, [unitsCounter, update]); // eslint-disable-line

  const handleDreamInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setDream(text);
  };

  const handleContextInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setContext(text);
  };

  const handleClick = async () => {
    setValueClean("");
    setRelevant("");
    setInterpretation("");
    setDreamId("");
    setLoading(true);

    const response = await chat(style, dream, context, language, uid, ip);
    if (window.TextDecoderStream) {
      const reader = response.body
        ?.pipeThrough(new TextDecoderStream())
        ?.getReader();
      let received = "";
      if (reader) {
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          received += value;
          setLoading(false);
          // console.log("Received: ", value);
          setValueClean((prev) => prev + value);
          setUpdate(update + 1);
          if (value.includes("interpretationId")) {
            const interpretationId = value.replace("\ninterpretationId: ", "");
            setDreamId(interpretationId);

            const lines = received.split("\ninterpretationId: ");
            const _interpretation = lines[0];
            setInterpretation(_interpretation);
          }
        }
      }
    } else {
      // Fallback or notify the user that their browser isn't supported.
      const data = await response.arrayBuffer();
      const text = new TextDecoder().decode(data);

      setValueClean(text);
      if (text.includes("interpretationId")) {
        const interpretationId = text.replace("\ninterpretationId: ", "");
        setDreamId(interpretationId);

        const lines = text.split("\ninterpretationId: ");
        const _interpretation = lines[0];
        setInterpretation(_interpretation);
      }

      setLoading(false);
    }
  };

  const handleUpgradeClick = () => {
    setPriceTable(!priceTable);
  };
  const handlePositifFeedback = async () => {
    setRelevant("positif");
    if (uid) {
      await postFeedback(uid, "0.0.0.0", dreamId, true);
    } else if (ip) {
      await postFeedback("", ip, dreamId, true);
    }
  };

  const handleNegatifFeedback = async () => {
    setRelevant("negatif");
    if (uid) {
      await postFeedback(uid, "0.0.0.0", dreamId, false);
    } else if (ip) {
      await postFeedback("", ip, dreamId, false);
    }
  };
  return (
    <HomepageBox>
      <ButtonLanguage language="fr" />
      <Versions whichVersion={1} />

      {!isAuth ? (
        <>
          <PageDescription textAlign="center">
            <b>
              🇬🇧 Free Units:
              <br />
              {unitsCounter >= 0 && unitsCounter < 3 ? 2 - unitsCounter : 0}/2
            </b>
          </PageDescription>
          <Link to="/login">
            <ButtonMorpheus>Register or Login</ButtonMorpheus>
          </Link>
        </>
      ) : (
        <>
          <PageDescription textAlign="center">
            <b>{authData.prenom + " " + authData.nom}</b> 👋 (
            {authData.subsription}
            {authData.subsription === "free"
              ? ` - ${10 - unitsCounter}
          /10`
              : authData.subsription === "circle" ||
                authData.subsription === "standard"
              ? ` - ${15 - unitsCounter}
            /15`
              : "✨"}
            )
          </PageDescription>
          {(authData.subsription === "free" ||
            authData.subsription === "circle" ||
            authData.subsription === "premium") && (
            <ButtonMorpheus onClick={handleUpgradeClick}>
              Upgrade
            </ButtonMorpheus>
          )}

          {successSub && (
            <SuccessBox>
              <SuccessIcon src={checkButton} />
              <SuccessText>Subscription updated successfully!</SuccessText>
            </SuccessBox>
          )}
        </>
      )}

      <Panel language="en">
        <div>
          <p>
            <MQEA>Morpheus</MQEA> is a figure rooted in Greek mythology, often
            hailed as the deity of dreams. Inspired by this legacy, the web app
            <MQEA>Ask Morpheus</MQEA> aspires to be the contemporary touchstone
            for dream interpretation.
          </p>
          <p>
            Leveraging cutting-edge technology, <MQEA>Ask Morpheus</MQEA> taps
            into artificial intelligence to dissect and elucidate dreams. By
            considering recurring themes, cultural nuances, and tied emotions,
            this AI renders a tailored and deep-seated interpretation.
          </p>
          <p>
            <b>Instructions:</b>
          </p>
          <p>
            <ul>
              <li>
                The richer and more detailed your dream description, the sharper
                the interpretation will be.
              </li>
              <br />
              <li>
                If your dream features individuals you know, clarify your
                relationship to them. For instance, rather than noting "I dreamt
                of John, we were in a car," it would be more insightful to
                specify, "I dreamt of <b>my cousin</b> John, and we were in a
                car."
              </li>
            </ul>
          </p>
        </div>
      </Panel>

      {priceTable ? <SubscriptionFR /> : <></>}
      {!isAuth ? (
        unitsCounter < 2 ? (
          <></>
        ) : (
          <>
            <PageDescription textAlign="center">
              🇬🇧 You have reached the limit of your available free units. <br />{" "}
              Please register or login to continue using{" "}
              <MQEA>Ask Morpheus</MQEA>.
            </PageDescription>
          </>
        )
      ) : (
        <></>
      )}
      <Divider />
      <SelectBox>
        <Label>Method:</Label>
        <SelectLab
          value={style}
          name={style}
          onChange={(event) => {
            setStyle(event.target.selectedOptions[0].label);
          }}
        >
          {styles.map((style, index) => (
            <StyledOption key={index} value={style}>
              {style}
            </StyledOption>
          ))}
        </SelectLab>
      </SelectBox>
      <SelectBox>
        <Label>Language:</Label>
        <SelectLab
          value={language}
          name={language}
          onChange={(event) => {
            setLanguage(event.target.selectedOptions[0].label);
          }}
        >
          {languages.map((language, index) => (
            <StyledOption key={index} value={language}>
              {language}
            </StyledOption>
          ))}
        </SelectLab>
      </SelectBox>
      <ChatBox>
        <InterpretationBox>
          {authData && authData.pic && <LogoImg src={authData.pic} />}
          <div>
            <Label>Dream:</Label>
            <Textarea
              onChange={handleDreamInput}
              // onKeyDown={handleKeyDown}
              placeholder="Write down your dream ..."
            />
          </div>
        </InterpretationBox>
        <Divider />

        <InterpretationBox>
          {authData && authData.pic && <LogoImg src={authData.pic} />}
          <div>
            <Label>Context:</Label>
            <Textarea
              onChange={handleContextInput}
              // onKeyDown={handleKeyDown}
              placeholder="Write down your personal context"
            />
          </div>
        </InterpretationBox>
        {loading ? (
          <LoaderBox>
            <Dna
              visible={true}
              height="80"
              width="80"
              ariaLabel="dna-loading"
              wrapperStyle={{}}
              wrapperClass="dna-wrapper"
            />
          </LoaderBox>
        ) : dream.length > 15 ? (
          !isAuth ? (
            unitsCounter < 2 ? (
              <SendButtonBox>
                <ButtonMorpheus onClick={handleClick}>
                  Send <span className="material-icons">arrow_upward</span>
                </ButtonMorpheus>
              </SendButtonBox>
            ) : (
              <Link to="login">
                <ButtonMorpheus>Register/Sign In</ButtonMorpheus>
              </Link>
            )
          ) : (
            <SendButtonBox>
              <ButtonMorpheus onClick={handleClick}>
                Send <span className="material-icons">arrow_upward</span>
              </ButtonMorpheus>
            </SendButtonBox>
          )
        ) : (
          <SendButtonBox>
            <ButtonMorpheus disabled>
              Send <span className="material-icons">arrow_upward</span>
            </ButtonMorpheus>
          </SendButtonBox>
        )}
      </ChatBox>

      {valueClean && (
        <>
          <PageTitleBox>
            <PageSubTitleH3>Morpheus interpretation:</PageSubTitleH3>
          </PageTitleBox>
          <br />
          <InterpretationBox>
            <LogoImg src={morpheus} />
            <Interpretation style={{ whiteSpace: "pre-wrap" }}>
              {interpretation ? interpretation : valueClean}
            </Interpretation>
          </InterpretationBox>
        </>
      )}

      {
        // Display Upgrade Button for "free" sub and counter greater than 3
        authData.subsription === "free" && unitsCounter > 10 && (
          <ButtonMorpheus onClick={handleUpgradeClick}>Upgrade</ButtonMorpheus>
        )
      }
      {
        // Display Upgrade Button for "premium"/"circle" sub and counter greater than 15
        (authData.subsription === "circle" ||
          authData.subsription === "premium") &&
          unitsCounter > 15 && (
            <ButtonMorpheus onClick={handleUpgradeClick}>
              Upgrade
            </ButtonMorpheus>
          )
      }
      {interpretation &&
        (relevant !== "" ? (
          <>
            <PageDescription>
              {relevant === "positif" ? "👍" : "👎"}
            </PageDescription>
          </>
        ) : (
          <>
            <PageDescription>
              <b>Is the interpretation relevant?</b>
            </PageDescription>
            <BoxRow>
              <ButtonNeumorphicRoot onClick={handlePositifFeedback}>
                👍
              </ButtonNeumorphicRoot>
              <ButtonNeumorphicRoot onClick={handleNegatifFeedback}>
                👎
              </ButtonNeumorphicRoot>
            </BoxRow>
          </>
        ))}
    </HomepageBox>
  );
}

export default Homepage;
